"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKModal = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var common_1 = require("../../common");
var hooks_1 = require("../../common/hooks");
var components_1 = require("../../components");
require("./GKModal.css");
/**
 * Simple modal dialog container
 *
 * @remarks
 * See the Reactstrap docs for Modals: https://reactstrap.github.io/components/modals/
 */
var GKModal = function (props) {
    var isTabletSized = (0, hooks_1.useDeviceSizes)().isTabletSized;
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-modal",
    }), centered = _a.centered, className = _a.className, isOpen = _a.isOpen, toggle = _a.toggle, mergedProps = __rest(_a, ["centered", "className", "isOpen", "toggle"]);
    var content = isTabletSized ? (React.createElement(components_1.FullscreenOverlay, { isOpen: isOpen, toggle: toggle },
        React.createElement("div", __assign({}, mergedProps, { className: className + " modal-content" })))) : (React.createElement(reactstrap_1.Modal, __assign({ centered: centered, isOpen: isOpen, className: className, toggle: toggle }, mergedProps)));
    return React.createElement(components_1.GKAlertsManager, { global: true }, content);
};
exports.GKModal = GKModal;
exports.default = exports.GKModal;
